module.exports = __webpack_public_path__ + "static/media/apple-watch.c51a5f8c.png";